import React, { useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { acceptInvitation, verifyEmail } from "../redux/action/action";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../helpers/helper";

function VerifyEmail() {
  const query = useQuery();
  const rs = query.get("rs");
  const account = query.get("account");

  const dispatch = useDispatch();
  const [message, setMessage] = React.useState("Verifying Email...");

  useEffect(() => {
    if (!account || !rs) return (window.location.href = "/error");
    dispatch(
      verifyEmail(
        account,
        rs,
        () => setMessage("Failed to verify email. Kindly try again"),
        () =>
          setMessage(
            "Email Confirmed successfully!. You can close this page now"
          )
      )
    );
  }, [account, dispatch, rs]);
  return (
    <div className="loading-page">
      <div className="flex justify-center column align-center ">
        <img src="/images/logo.png" alt="logo" className="logo" />
        <p className="bold mt-1">{message} </p>

        {message === "Failed to verify email. Kindly try again" ||
        message ===
          "Email Confirmed successfully!. You can close this page now" ? (
          <button className="btn" onClick={() => (window.location.href = "/")}>
            Go Home
          </button>
        ) : (
          <>
            <BeatLoader color="#6f2da8" size={10} />
            <p className=" cercle-purple-text ">Loading...</p>
          </>
        )}
      </div>
    </div>
  );
}
export default VerifyEmail;
